import * as React from "react";
import cx from "classnames";

const styles = require("./sideBar.scss");

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

interface IHeaderProps extends IProps {
  left: React.ReactNode;
  right?: React.ReactNode;
}

const SideBar: React.FC<IProps> = ({ className, children }) => {
  return <div className={cx(styles.wrapper, className)}>{children}</div>;
};

const Header: React.FC<IHeaderProps> = ({ left, right, className }) => {
  return (
    <header className={cx(styles.header, className)}>
      <div className={styles.left}>{left}</div>
      <div className={styles.right}>{right}</div>
    </header>
  );
};

export default SideBar;
export { Header };
